/**
 * Trix workaround to open links in new tab
 * https://github.com/basecamp/trix/issues/55
 */
addEventListener("click", (event) => {
  var el = event.target

  if (el.tagName === "A" && !el.isContentEditable && el.host !== window.location.host)
    el.setAttribute("target", "_blank")
}, true)